import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeService } from '../../services/theme/theme.service';
import { FormColorService } from '@formbird/services';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatTooltipModule],
  template: `
    <button 
      mat-icon-button 
      (click)="toggleTheme()"
      [matTooltip]="isDarkMode() ? 'Switch to Light Theme' : 'Switch to Dark Theme'"
      aria-label="Toggle theme"
      class="theme-toggle-btn">
      <mat-icon class="theme-icon">{{ isDarkMode() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
  `,
  styles: [`
    :host {
      display: inline-block;
    }
    
    .theme-toggle-btn {
      color: inherit;
      transition: transform 0.2s ease-in-out;
    }
    
    .theme-toggle-btn:hover {
      transform: scale(1.1);
    }
    
    .theme-icon {
      transition: transform 0.3s ease-in-out;
    }
    
    .theme-toggle-btn:hover .theme-icon {
      transform: rotate(180deg);
    }
  `]
})
export class ThemeToggleComponent {
  private themeService = inject(ThemeService);
  private formColorService = inject(FormColorService);
  
  isDarkMode = this.themeService.getTheme();
  
  toggleTheme(): void {
    this.themeService.toggleTheme();
    this.formColorService.updateBackground();
  }
}
